// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2019-06-13T13:49:23Z                      #

// ##############################################################

import {utils} from "mc/lib";
const {ErrorApi, JsonFetch, Fetch, ParamsFetch} = utils;

import * as UpdateMethods from "./UpdateMethods";

/**
 * API pro žádosti. Generated from cz.marbes.pop.controller.ZadostController.
 */
export default class ZadostApi {
    /**
     * 
     *
     * @param ids 
     * @return 
     */
    static findByIds(ids : number[]) : Promise<ZadostVO[]> {
        const uri = serverContextPath + `/api/zadost/search-by-ids`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, ids, headers));
    }

    /**
     * 
     *
     * @param filter 
     * @return 
     */
    static findIdsByFilter(filter : ZadostFilterVO) : Promise<number[]> {
        const uri = serverContextPath + `/api/zadost/ids/search-by-filter`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, UpdateMethods.updateZadostFilterVO_63E1B9(filter), headers));
    }

    /**
     * 
     *
     * @return 
     */
    static exportPredpisuAPlateb() : Promise<string> {
        const uri = serverContextPath + `/api/zadost/exportPredpisuAPlateb`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param id 
     * @return 
     */
    static getById(id : number) : Promise<ZadostVO> {
        const uri = serverContextPath + `/api/zadost/${id}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

}